import { ExternalLink, Mail } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import env from 'env';

import BillingPlanFeatures from './BillingPlanFeatures';

const BillingFreePlan = () => {
  const onContactUs = () => {
    window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');
  };

  const onUpgradePlan = () => {
    window.open('https://codekeeper.co/pricing', '_blank');
  };

  return (
    <Card className={'p-6 space-y-6 bg-accent'}>
      <div className="relative flex-col sm:flex-row flex justify-between items-start sm:items-start gap-2">
        <div className="flex flex-col gap-1 grow-1">
          <h6 className="text-sm sm:text-lg font-semibold text-foreground">Free Plan</h6>
          <p className="text-xs sm:text-sm text-muted-foreground">
            Our free plan offers a solid start for your software resilience efforts. Add additional controls by
            upgrading to a paid plan.
          </p>
        </div>
        <Badge className="bg-muted-foreground whitespace-nowrap">Free plan</Badge>
      </div>
      <BillingPlanFeatures
        title="Why upgrade?"
        footer="... and more."
        textAccentColor="text-muted-foreground"
        features={[
          'Easy escrow setups',
          'Managed software backups',
          'Certified proof of continuity',
          'Full legal support',
        ]}
      />
      <div className="flex justify-end flex-col sm:flex-row gap-3">
        <Button variant="outline" onClick={onContactUs}>
          <Mail /> Contact us
        </Button>
        <Button onClick={onUpgradePlan}>
          Upgrade plan <ExternalLink />
        </Button>
      </div>
    </Card>
  );
};

export default BillingFreePlan;
